import t from 'common/i18n';

let _rightOptions;

export default () => {
  if (!_rightOptions) {
    _rightOptions = [
      {
        text: t('image_search.rights_options.not_filtered'),
        value: '',
      },
      {
        text: t('image_search.rights_options.free'),
        value: 'cc_publicdomain|cc_attribute|cc_sharealike|cc_noncommercial|cc_nonderived',
      },
      {
        text: t('image_search.rights_options.free_com'),
        value: 'cc_publicdomain|cc_attribute|cc_sharealike|cc_nonderived',
      },
      {
        text: t('image_search.rights_options.free_mod'),
        value: 'cc_publicdomain|cc_attribute|cc_sharealike|cc_noncommercial',
      },
      {
        text: t('image_search.rights_options.free_mod_com'),
        value: 'cc_publicdomain|cc_attribute|cc_sharealike',
      },
    ];
  }

  return _rightOptions;
};
